import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore/lite";
import { getAuth } from "firebase/auth";

//le 08/03/2026
const firebaseConfig = {
  apiKey: "AIzaSyBju8uD2P0AGQ--_f4qGMM_OgfG6skUMEo",
  authDomain: "portfolio-leach.firebaseapp.com",
  projectId: "portfolio-leach",
  storageBucket: "portfolio-leach.firebasestorage.app",
  messagingSenderId: "417987258005",
  appId: "1:417987258005:web:eb685e9a87a65ef91e5d9c",
  measurementId: "G-H0V6R5BB5V"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth();